import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import './OtherFeatures.css';
import easy from "../../Assets/voice.webp";
import advance from "../../Assets/confidence.webp";
import inter from "../../Assets/impact.webp";
import PopupForm from '../../Form/PopupForm';

function OtherFeatures() {
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });
  const [showForm, setShowForm] = useState(false);

  const features = [
    {
      image: easy,
      title: 'VOICE FINDER',
      description:
        'In this beginner level, learners will be able to introduce themselves, ask and answer basic questions, hold simple conversations, and use day-to-day English confidently.',
    },
    {
      image: inter,
      title: 'CONFIDENCE BUILDER',
      description:
        'In this Intermediate level, you will be able to express opinions, handle real-life conversations, describe events and situations, and use tenses and vocabulary more fluently.',
    },
    {
      image: advance,
      title: 'IMPACT SPEAKER',
      description:
        'In this Advanced level, you will be able to engage in complex discussions, express abstract ideas clearly, use idiomatic language naturally, and speak fluently in academic, business, and social contexts.',
    },
  ];

  const handleOpenForm = () => setShowForm(true);
  const handleCloseForm = () => setShowForm(false);

  return (
    <section id="download" className="other-features">
      <div className="container">
        <div className="section-header">
          <div className="decorative-line" />
          <h1>Our Courses</h1>
          <div className="decorative-line" />
        </div>

        <div className={`features-grid ${inView ? 'animate' : ''}`} ref={ref}>
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-image-container">
                <img
                  src={feature.image}
                  alt={feature.title}
                  width={150}
                  height={200}
                  loading="lazy"
                  decoding="async"
                  className="feature-image"
                />
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <div className="feature-description">
                <p>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="download-cta">
          <button onClick={handleOpenForm} className="download-btn">
            Free Trial
          </button>
          <p className="platforms">
            We bridge the language gap by teaching English through your mother tongue.
          </p>
        </div>
      </div>

      {/* Pass showForm as isOpen prop */}
      <PopupForm isOpen={showForm} onClose={handleCloseForm} />
    </section>
  );
}

export default OtherFeatures;
